<template>
  <el-dialog
    v-model="dialogFormVisible"
    :title="title"
    width="500px"
    @close="close"
  >
    <el-form ref="form" label-width="80px" :model="form" :rules="rules">
      <el-form-item v-if="!branchId && !isEdit" label="门店" prop="branchId">
        <el-select v-model="form.branchId" clearable placeholder="请选择门店" @change="depSearchAsync">
          <el-option
            v-for="item in branchs"
            :key="item.branchId"
            :label="`${item.title}`"
            :value="item.branchId"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="!branchId && isEdit" label="门店" prop="branchId">
        {{ branchTitle }}
      </el-form-item>
      <el-form-item label="工号" prop="customId">
        <el-input v-model.trim="form.customId" />
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model.trim="form.password" type="password" />
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model.trim="form.name" />
      </el-form-item>
      <el-form-item label="手机号" prop="tel">
        <el-input v-model.trim="form.tel" />
      </el-form-item>
      <el-form-item label="职务" prop="title">
        <el-input v-model.trim="form.title" />
      </el-form-item>
            <el-form-item label="选择部门" prop="departmentId">
        <el-autocomplete
          v-model="form.departmentName"
          :fetch-suggestions="depSearchAsync"
          placeholder="查询部门"
          @select="depSelect"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="头像" prop="avatar">
        <el-upload
          :action="QNUploadURL"
          :data="uploadToken"
          :limit="1"
          :multiple="false"
          :before-upload="beforeAvatarUpload"
          class="avatar-uploader"
          :on-success="handleAvatarSuccess"
          :on-remove="image_remove"
          :show-file-list="false"
        >
          <img v-if="form.avatar" class="avatar" :src="form.avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <span>建议尺寸：200px * 200px, 不超过500KB</span>
      </el-form-item>
      <!-- <el-form-item label="职业照" prop="jobAvatar">
        <el-upload
          :action="uploadURL"
          :before-upload="beforeAvatarUpload"
          class="avatar-uploader"
          :on-success="handleJobAvatarSuccess"
          :show-file-list="false"
        >
          <img v-if="form.jobAvatar" class="job-avatar" :src="form.jobAvatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <span>建议尺寸：670px * 504px, 不超过500KB</span>
      </el-form-item> -->
      <el-form-item label="简介" prop="text">
        <el-input v-model.trim="form.text" type="textarea" />
      </el-form-item>
      <el-form-item label="排序" prop="order">
        <el-input-number v-model="form.order" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import storejs from 'store'
import { addStaff, getAllBranchs,getDepartments } from '@/api/branch'
import { QNUploadURL, QNHost } from '@/config/net.config'
import { getUploadToken } from '@/api/app'

export default {
  name: 'RoleEdit',
  emits: ['fetch-data'],
  data() {
    return {
      QNUploadURL,
      uploadToken:'',
      branchs: [],
      branchTitle: '',
      branchId: '',
      isEdit: false,
      form: {
        branchId: '',
        customId: '',
        password: '',
        title: '',
        departmentName:'',
        departmentId:'',
        name: '',
        avatar: '',
        // jobAvatar: '',
        text: '',
        order: 0,
      },
      rules: {
        name: [{ required: true, trigger: 'blur', message: '请输入用户名' }],
        tel: [{ required: true, trigger: 'blur', message: '请输入手机号' }],
        customId: [{ required: true, trigger: 'blur', message: '请输入工号' }],
        password: [{ required: true, trigger: 'blur', message: '请输入密码' }],
        title: [{ required: true, trigger: 'blur', message: '请填写职务' }],
        avatar: [],
        jobAvatar: [],
        text: [],
        order: [],
      },
      title: '',
      dialogFormVisible: false,
    }
  },
  mounted() {
    const me = storejs.get('me')
    this.branchId = me.extra.branchId || ''
  },
  methods: {
    depSelect(item) {
      console.log(item)
      this.form.departmentName = item.value
      this.form.departmentId = item.departmentId
    },
    async depSearchAsync(keyword, cb) {
      const ret = await getDepartments({
        keyword,
        branchId: this.form.branchId || 'group',
        page: 1,
        size: 30,
      })
      cb(
        ret.list.map((e) => ({
          value: e.title,
          departmentId: e.departmentId,
        }))
      )
    },
    async getBranchs() {
      this.branchs = await getAllBranchs()
    },
    handleAvatarSuccess(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.avatar = QNHost + '/' + res.hash
    },
    image_remove(file, fileList) {
      this.form.avatar = ''
    },
    handleJobAvatarSuccess(res) {
      console.log('res', res.data.url)
      this.form.jobAvatar = res.data.url
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return (isJPG || isPNG) && isLt2M
    },
    async showAdd() {
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
      this.title = '新增员工'
      this.branchTitle = ''
      this.isEdit = false
      this.form = {}
      this.dialogFormVisible = true
      this.getBranchs()
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          await addStaff(this.form)
          this.$baseMessage(
            '新增员工成功',
            'success',
            false,
            'vab-hey-message-success'
          )
          this.$emit('fetch-data')
          this.close()
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style style="scss" scoped>
:deep(.el-upload) {
  border: 1px dashed #81878f;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.job-avatar {
  width: 335px;
  height: 252px;
  display: block;
}
</style>
